<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4470_79245)">
<rect y="-0.000488281" width="20" height="20" rx="3" />
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.3141 6.79289C13.7047 6.40237 14.3378 6.40237 14.7284 6.79289C15.1189 7.18342 15.1189 7.81658 14.7284 8.20711L8.72836 14.2071C8.33783 14.5976 7.70467 14.5976 7.31414 14.2071L4.79289 11.6859C4.40237 11.2953 4.40237 10.6622 4.79289 10.2716C5.18342 9.88112 5.81658 9.88112 6.20711 10.2716L8.02125 12.0858L13.3141 6.79289Z" fill="#FBFBFB"/>
</g>
<defs>
<clipPath id="clip0_4470_79245">
<rect width="20" height="20" />
</clipPath>
</defs>
</svg>
